export const getTranslationFormatNameFromAction = (name: string) =>
  name
    .split(/(?=[A-Z])/)
    .map((str: string) => str.toUpperCase())
    .join("_");
